<template>
    <div :class="['dropdown', customClass]">
        <div :class="{toggle: true, 'has-active': active}" @click="onToggle">
            <slot name="toggle"></slot>
        </div>

        <transition :name="`${transition}`">
            <div class="menu" :class="`${align}`" v-show="active" @click.stop="onClick">
                <div class="menu-wrap">
                    <slot></slot>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        name: "Dropdown",
        props: {
            select: {
                type: Boolean,
                default: false
            },

            selected: {
                type: String,
                default: ""
            },

            closeAfterClick: {
                type: Boolean,
                default: true
            },

            customClass: {
                type: String,
                default: ""
            },

            align: {
                type: String,
                default: 'top left'
            },

            transition: {
                type: String,
                default: "fade-height"
            }
        },

        data() {
            return {
                active: false,
                toggle: null,
                // options: null,
                localSelected: null
            };
        },

        mounted() {
            this.toggle = this.$el.querySelector('.toggle');
        },

        watch: {
            active(active) {
                var vm = this;
                if (active) {
                    document.addEventListener('click', function clickOutside(e) {
                        vm.onClose(e);
                        document.removeEventListener('click', clickOutside, false);
                    }, false);
                }
            },

            selected(selected) {
                this.updateLocalSelected(selected);
            },

            localSelected(localSelected) {
                var toggleLink = this.toggle.querySelector('.link');
                var toggle = toggleLink !== null ? toggleLink : this.toggle;

                var selected = this.$el.querySelector(`.menu [data-option="${localSelected}"]`);

                if (selected) {
                    var value = selected.getAttribute('data-value');

                    if (value) {
                        toggle.innerHTML = value;
                    } else {
                        selected.classList.remove('is-active');
                        toggle.innerHTML = selected.outerHTML;
                    }

                    var activeNodes = this.$el.querySelectorAll('.menu .is-active');
                    if (activeNodes) {
                        for (var i = 0; i < activeNodes.length; i++) {
                            activeNodes[i].classList.remove('is-active');
                        }
                    }

                    selected.classList.add('is-active');
                }
            }
        },

        methods: {
            onToggle() {
                this.active = !this.active;
            },

            onClose(e) {
                if (typeof e !== 'undefined') {
                    if (this.$el.contains(e.target)) return;
                }
                this.active = false;
            },

            onClick(e) {
                if (this.select) this.setLocalSelected(e);
                if (this.closeAfterClick) this.onClose();
            },

            setLocalSelected(e) {
                let node = e.target;

                while (node && node !== this.$el) {
                    let nodeName = node.nodeName.toLowerCase();
                    if (nodeName === 'a' || nodeName === 'button') {
                        var option = node.getAttribute('data-option');
                        if (option !== this.localSelected) {
                            this.localSelected = option;
                            this.$emit('selected-changed', option);
                        }
                        return;
                    }
                    node = node.parentNode;
                }
            },

            updateLocalSelected(selected) {
                this.localSelected = selected;
            }
        }
    };
</script>
